import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaHome, FaServer, FaMapMarkerAlt } from 'react-icons/fa';
import './Footer.css';

/**
 * Footer component - Bottom navigation bar with main app sections
 * @returns {JSX.Element} The rendered footer navigation with active state indicators
 */
const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  /**
   * Determines if a navigation path is currently active
   * @param {string} path - The path to check against current location
   * @returns {boolean} True if the path matches current location, false otherwise
   */
  const isActive = (path) => {
    return location.pathname === path;
  };
  
  return (
    <footer className="footer">
      <div 
        className={`footer-item ${isActive('/dashboard') ? 'active' : ''}`}
        onClick={() => navigate('/dashboard')}
      >
        <FaHome className="footer-icon" />
        <span className="footer-text">Home</span>
      </div>
      
      <div 
        className={`footer-item ${isActive('/system') ? 'active' : ''}`}
        onClick={() => navigate('/system')}
      >
        <FaServer className="footer-icon" />
        <span className="footer-text">System</span>
      </div>
      
      <div 
        className={`footer-item ${isActive('/location') ? 'active' : ''}`}
        onClick={() => navigate('/location')}
      >
        <FaMapMarkerAlt className="footer-icon" />
        <span className="footer-text">Location</span>
      </div>
      
    </footer>
  );
};

export default Footer;